import type { Conversation } from '@twilio/conversations';

import { ConversationChatView } from '../ChatScreen/ConversationChatView';

type UpdatesConversationContentProps = {
  conversation: Conversation | null;
  inlineTitle?: string;
};

const UpdatesConversationContent = ({
  conversation,
  inlineTitle,
}: UpdatesConversationContentProps) => (
  <ConversationChatView
    conversation={conversation}
    emptyMessage={'No updates yet.'}
    hideSenderIdentity={true}
    inlineTitle={inlineTitle}
    readOnly={true}
  />
);

export { UpdatesConversationContent };
